import { useQuery } from '@tanstack/react-query'
import { ProjectService } from 'src/services/project.service'
import { ErrorQueryHandler } from 'src/components/error/error-query-handler.component'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { UpdatePermissionForm } from 'src/pages/configuration/permissions/_components/permissions-form.component'
import { ConfigurationHeaderWrapper } from '../../_components/configuration-header-wrapper.component'
import { TPermissionFormValues } from '../_components/permissions.type'
import { expandGrantActions } from '../_components/permissions.util'

export default function UpdatePermissionPage() {
  const { t } = useTranslation()
  const { permissionId: permissionIdParam } = useParams<{ permissionId: string }>()
  const permissionId = Number(permissionIdParam)
  const { project } = useCurrentProject()

  const {
    isLoading,
    error,
    data: permission,
  } = useQuery({
    queryKey: ['permission', project.id, permissionId],
    queryFn: () => ProjectService.getPermission(project.id, permissionId),
  })

  if (error) return <ErrorQueryHandler error={error} />
  if (isLoading || !permission) return <div className="loading" />

  const defaultValues: TPermissionFormValues = {
    name: permission.name ?? '',
    specialAuthorizations: permission.specialAuthorizations ?? [],
    grants: expandGrantActions(permission.grants ?? []),
    ipAddressWhiteList: permission.ipAddressWhiteList ?? [],
  }

  return (
    <ConfigurationHeaderWrapper title={t('pages.configuration.permissions.title-update-permission')}>
      <UpdatePermissionForm defaultValues={defaultValues} permissionId={permissionId} />
    </ConfigurationHeaderWrapper>
  )
}
